import { CustomSvgIcon } from "modules/common/components/CustomSvgIcon"

export const ArrowPrev = () => (
  <CustomSvgIcon width={17} height={15} viewBox="0 0 17 15" fill="none" style={{ width: 20, height: 20}}>
    <path d="M2.33301 7.33355L16.333 7.33355M2.33301 7.33355L8.63301 1.11133M2.33301 7.33355L8.63301 13.5558" stroke="#FDFF5D" strokeWidth="2"/>
  </CustomSvgIcon>
)
